<template>
  <div id="app">
    <v-app style="height: 100%">
      <page-header></page-header>
      <v-main id="main" style="height: 100%">
        <router-view></router-view>
        <loading
          :active.sync="isLoading"
          :is-full-page="false"
          :width="50"
          :height="50"
          style="z-index: 20"
        ></loading>
      </v-main>
    </v-app>

    <notifications position="bottom right" />
  </div>
  <!-- <div id="app" data-app>
 
  </div> -->
</template>

<script>
import PageHeader from "@/layouts/Header";
import Api from "./services/Api";
import Loading from "vue-loading-overlay";

export default {
  name: "App",
  data() {
    return {
      drawer: false,
      group: null,
      links: ["Dashboard", "Messages", "Profile", "Updates"]
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 220;
        case "sm":
          return 400;
        case "md":
          return 500;
        case "lg":
          return 600;
        case "xl":
          return 800;
      }
    }
  },
  components: {
    PageHeader,
    Loading
  },
  async created() {
    try {
      if (!this.$store.state.token) return;
      this.$store.dispatch("setLoading", true);
      let res = await Api.get("v1/service/get-data", {
        timeout: 60 * 1000
      });
      if (res && res.status === 200) {
        let data = res.data.data;
        this.$store.dispatch("setData", data);
        if (res.data.videos) {
          this.$store.dispatch("setListVideo", res.data.videos.listVideo);
          this.$store.dispatch("setTotalPageVideo", res.data.videos.totalPage);
          this.$store.dispatch("setTotalVideo", res.data.videos.totalVideo);
        }
      } else if (res.status === 401) {
        this.$router.push("signin");
        this.$store.dispatch("setUser", null);
      }
    } catch (error) {
      console.log(error);
      this.$notify({
        type: "error",
        title: "Lỗi Get Data: " + error
      });
    }
    this.$store.dispatch("setLoading", false);
  }
};
</script>

<style>
/* #app {
  background-color: rgb(240, 242, 245);
} */
#result-text {
  text-align: center !important;
}
.v-label {
  font-size: 14px !important;
}

.v-input {
  font-size: 14px !important;
}

.small-radio i {
  font-size: 19px;
}
.small-radio label {
  font-size: 14px;
  padding-left: 0px;
  margin-left: -4px;
  font-weight: 400;
  color: black !important;
}
.small-radio .v-radio {
  padding: 0px;
}
.small-radio [class*="__ripple"] {
  left: 0;
}

.radius-20 {
  border-radius: 20px;
}
.v-tabs-slider-wrapper {
  height: 0px !important;
}
.v-tab--active {
  color: black !important;
  font-weight: bold;
}
.v-application {
  font-family: "Roboto", "Arial", sans-serif !important;
  font-weight: 400 !important;
}
html {
  overflow-y: hidden !important;
}
body {
  height: 100vh;
  font-family: "Roboto", sans-serif;
  font-weight: 400 !important;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  font-family: "Roboto", sans-serif;
  font-weight: 400 !important;
}
#main {
  overflow-y: auto;
}

.v-btn {
  text-transform: none !important;
}

.reset {
  margin: 0px !important;
  padding: 0px !important;
}
.color-picker-container {
  box-shadow: 1px 1px 10px black !important;
}
.text-bold {
  font-weight: bold;
}
.truncate-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.fa-trash-alt:hover {
  color: red;
}

.fs-20 {
  font-size: 20px !important;
}
.fs-18 {
  font-size: 18px !important;
}
.fs-16 {
  font-size: 16px !important;
}
.fs-15 {
  font-size: 15px !important;
}

.fs-14 {
  font-size: 14px !important;
}
.fs-12 {
  font-size: 12px !important;
}
.fs-10 {
  font-size: 10px !important;
}
.fs-sm {
  font-size: 0.875rem !important;
}
.fs-md {
  font-size: 1rem !important;
}
.fs-lg {
  font-size: 1.25rem !important;
}
.fs-xl {
  font-size: 1.5rem !important;
}
.btn-radius {
  border-radius: 50px !important;
}
.text-gray {
  color: rgb(100, 100, 100);
}

.wrapper-item-input {
  background-color: rgb(255, 255, 255);
  box-shadow: none;
  cursor: pointer;
  height: 42px;
  font-size: 13px;
  transition: all 0.1s ease 0s;
  border: 1px solid #dcdcde;
  border-radius: 5px !important;
  font-weight: bold;
  padding: 0 10px;
}

@supports (-webkit-appearance: none) or (-moz-appearance: none) {
  input[type="checkbox"],
  input[type="radio"] {
    --active: #275efe;
    --active-inner: #fff;
    --focus: 2px rgba(39, 94, 254, 0.3);
    --border: #bbc1e1;
    --border-hover: #275efe;
    --background: #fff;
    --disabled: #f6f8ff;
    --disabled-inner: #e1e6f9;
    -webkit-appearance: none;
    -moz-appearance: none;
    height: 21px;
    outline: none;
    display: inline-block;
    vertical-align: top;
    position: relative;
    margin: 0;
    cursor: pointer;
    border: 1px solid var(--bc, var(--border));
    background: var(--b, var(--background));
    transition: background 0.3s, border-color 0.3s, box-shadow 0.2s;
  }
  input[type="checkbox"]:after,
  input[type="radio"]:after {
    content: "";
    display: block;
    left: 0;
    top: 0;
    position: absolute;
    transition: transform var(--d-t, 0.3s) var(--d-t-e, ease),
      opacity var(--d-o, 0.2s);
  }
  input[type="checkbox"]:checked,
  input[type="radio"]:checked {
    --b: var(--active);
    --bc: var(--active);
    --d-o: 0.3s;
    --d-t: 0.6s;
    --d-t-e: cubic-bezier(0.2, 0.85, 0.32, 1.2);
  }
  input[type="checkbox"]:disabled,
  input[type="radio"]:disabled {
    --b: var(--disabled);
    cursor: not-allowed;
    opacity: 0.9;
  }
  input[type="checkbox"]:disabled:checked,
  input[type="radio"]:disabled:checked {
    --b: var(--disabled-inner);
    --bc: var(--border);
  }
  input[type="checkbox"]:disabled + label,
  input[type="radio"]:disabled + label {
    cursor: not-allowed;
  }
  input[type="checkbox"]:hover:not(:checked):not(:disabled),
  input[type="radio"]:hover:not(:checked):not(:disabled) {
    --bc: var(--border-hover);
  }
  input[type="checkbox"]:focus,
  input[type="radio"]:focus {
    box-shadow: 0 0 0 var(--focus);
  }
  input[type="checkbox"]:not(.switch),
  input[type="radio"]:not(.switch) {
    width: 21px;
  }
  input[type="checkbox"]:not(.switch):after,
  input[type="radio"]:not(.switch):after {
    opacity: var(--o, 0);
  }
  input[type="checkbox"]:not(.switch):checked,
  input[type="radio"]:not(.switch):checked {
    --o: 1;
  }
  input[type="checkbox"] + label,
  input[type="radio"] + label {
    font-size: 15px;
    line-height: 21px;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
    margin-left: 4px;
  }
  input[type="checkbox"]:not(.switch) {
    border-radius: 7px;
  }
  input[type="checkbox"]:not(.switch):after {
    width: 5px;
    height: 9px;
    border: 2px solid var(--active-inner);
    border-top: 0;
    border-left: 0;
    left: 7px;
    top: 4px;
    transform: rotate(var(--r, 20deg));
  }
  input[type="checkbox"]:not(.switch):checked {
    --r: 43deg;
  }
  input[type="checkbox"].switch {
    width: 38px;
    border-radius: 11px;
  }
  input[type="checkbox"].switch:after {
    left: 2px;
    top: 2px;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    background: var(--ab, var(--border));
    transform: translateX(var(--x, 0));
  }
  input[type="checkbox"].switch:checked {
    --ab: var(--active-inner);
    --x: 17px;
  }
  input[type="checkbox"].switch:disabled:not(:checked):after {
    opacity: 0.6;
  }
  input[type="radio"] {
    border-radius: 50%;
  }
  input[type="radio"]:after {
    width: 19px;
    height: 19px;
    border-radius: 50%;
    background: var(--active-inner);
    opacity: 0;
    transform: scale(var(--s, 0.7));
  }
  input[type="radio"]:checked {
    --s: 0.5;
  }
}
/* Drag and Drop */
.drag-resize-item-active {
  border: 1px solid #38e7ff !important;
}

.item-right-content:hover {
  border: 1px solid #38e7ff !important;
}
.handle {
  background-color: turquoise !important;
  border-radius: 15px;
  margin: -2px;
  z-index: 99;
  width: 12px !important;
  height: 12px !important;
}

.handle.handle-tl {
  top: -3px !important;
  left: -3px !important;
}
.handle.handle-tm {
  top: -4px !important;
}
.handle.handle-tr {
  top: -3px !important;
  right: -3px !important;
}
.handle.handle-mr {
  right: -4px !important;
}
.handle.handle-br {
  right: -3px !important;
  bottom: -3px !important;
}
.handle.handle-bm {
  bottom: -4px !important;
}
.handle.handle-bl {
  bottom: -3px !important;
  left: -3px !important;
}
.handle.handle-ml {
  left: -4px !important;
}

.label {
  font-weight: 600;
  color: rgb(151, 151, 151);
}

.fhzWpZ {
  font-size: 30px;
  font-weight: 700;
  text-align: center;
  line-height: 1.1;
}
.btn-default {
  background-color: rgb(0, 152, 253) !important;
  color: white !important;
  font-weight: 500;
  border-radius: 7px;
}
.v-text-field__details {
  margin: 0 !important;
}
.icon-help-hover:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue